import * as R from 'ramda'
import { sprintf } from 'sprintf'

export const pricePerNoti = R.curry((price, notesQuantity) =>
  sprintf('%.4f', Number((price / notesQuantity).toFixed(4))),
)

export const applyThousandSeparator = (num) => num.toLocaleString()

export const displayCountLimit = (textCount, maxLength) =>
  R.compose(
    R.join('/'),
    R.map(applyThousandSeparator),
    R.filter(R.complement(R.isNil)),
  )([textCount, maxLength])
